import cn from "@/utils/cn"

type TabBadgeProps = {
  count: number
  active?: boolean
}

const TabBadge = ({ count, active = false }: TabBadgeProps) => (
  <span
    className={cn(
      "flex h-5 w-5 items-center justify-center rounded-full text-xs font-semibold",
      active ? "bg-primary text-white" : "bg-gray-200 text-primary/70"
    )}
  >
    {count}
  </span>
)

export default TabBadge
